export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [{
      text: '弹窗名称',
      name: 'name',
    }, {
      text: 'type',
      name: 'type',
      type: 'hidden',
    }, {
      name: 'maskClose',
      text: '点击蒙层关闭',
      type: 'switch',
      defaultValue: true,
    }, {
      name: 'isFromBottom',
      text: '从底部拉起',
      type: 'switch',
      defaultValue: false,
    }, {
      name: 'closeIScroll',
      defaultValue: true,
      type: 'switch',
      text: '关闭Iscroll',
    }, {
      name: 'closeButton',
      defaultValue: false,
      type: 'switch',
      display: (vm, { formValue }) => formValue && formValue.fuc !== 'share',
      text: '关闭按钮',
    }, {
      text: '关闭按钮颜色',
      name: 'closeBtnColor',
      type: 'colorPicker',
      display: (vm, { formValue }) => formValue && formValue.closeButton,
    }, {
      type: 'row',
      items: [
        {
          text: '延时自动关闭',
          name: 'autoClose',
          defaultValue: false,
          type: 'switch',
        },
        {
          text: '延迟时间(秒)',
          name: 'closeSecond',
          type: 'number',
          display: (vm, { formValue }) => formValue && formValue.autoClose,
        },
      ],
    }, {
      type: 'component',
      id: 'devConfig',
    }, {
      type: 'fieldset',
      text: '样式',
      labelWidth: '80px',
      items: [{
        type: 'component',
        id: 'background',
      }, {
        name: 'style',
        items: [{
          type: 'row',
          items: [{
            name: 'width',
            text: '宽度',
          }, {
            name: 'height',
            text: '高度',
          }],
        }],
      }],
    }, {
      name: 'items',
      type: 'hidden',
      defaultValue: [],
    }],
  }, {
    title: '高级',
    lazy: true,
    items: [{
      type: 'tab',
      active: '0',
      items: [{
        title: '属性',
        labelWidth: '100px',
        items: [{
          name: 'id',
          text: 'ID',
          type: 'display',
        }, {
          text: 'className',
          name: 'className',
        }, {
          type: 'fieldset',
          text: '上报',
          labelWidth: '100px',
          name: 'report',
          items: [{
            name: 'module',
            extensible: true,
            items: [{
              text: '_module',
              name: '_module',
            }],
          }],
        }],
      }, {
        type: 'component',
        id: 'script',
      }, {
        title: 'outHtml',
        lazy: true,
        items: [{
          name: 'outHtml',
          type: 'code',
          language: 'html',
          height: '100%',
        }],
      }],
    }],
  }],
}];
